var _rect, _rect2, _rect3, _rect4, _path, _path2, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 64,
    height: 96,
    rx: 8,
    fill: "#F4F6FB",
    stroke: "#C3CEDB",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 40,
    height: 8,
    rx: 4,
    fill: "#6C63FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 46,
    width: 28,
    height: 8,
    rx: 4,
    fill: "#B7C3D0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 62,
    width: 34,
    height: 8,
    rx: 4,
    fill: "#B7C3D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 28L102 48V98C102 101.314 99.3137 104 96 104H72C68.6863 104 66 101.314 66 98V34C66 30.6863 68.6863 28 72 28H82Z",
    fill: "#E3E8F5",
    stroke: "#6C63FF",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28V44C82 46.2091 83.7909 48 86 48H102",
    stroke: "#6C63FF",
    strokeWidth: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 58,
    width: 18,
    height: 6,
    rx: 3,
    fill: "#6C63FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 70,
    width: 22,
    height: 6,
    rx: 3,
    fill: "#6C63FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 82,
    width: 15,
    height: 6,
    rx: 3,
    fill: "#6C63FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.be9a1f0d05d694ba11a385c09d796fde.svg";
export { ForwardRef as ReactComponent };